module.exports = __webpack_public_path__ + "img/calendar-blue.0265e5eb.svg";